<template>
  <vv-screen-wrapper>
    <div v-if="items && items.length" :class="{ Cart: true, 'Cart--small': $mq === 'mobile' }">
      <h1>{{ t('title') }}</h1>

      <div class="ToShop" @click="$router.push({ name: 'shop-list-bottles' })">
        {{ t('toShop') }}
      </div>

      <div class="Row Header">
        <div class="Col Head Large">
          {{ t('header.product') }}
        </div>
        <div class="Col Head">
          {{ t('header.price') }}
        </div>
        <div class="Col Head">
          {{ t('header.quantity') }}
        </div>
        <div v-if="$mq !== 'mobile'" class="Col Head">
          {{ t('header.total') }}
        </div>
      </div>

      <div v-for="(item, index) in items" :key="item.id" class="Row Product">
        <!-- Product informations -->
        <div class="Col Large">
          <img class="ProductImage" :src="imageSrc(item)" />

          <div class="Informations">
            <div class="Name">{{ item.title }}</div>
            <div class="Remove" @click="onRemove(item)">{{ t('remove') }}</div>
            <label class="control control-checkbox" v-if="type(item) != 0">
              Cet article est un cadeau
              <input type="checkbox" @click="showOfferModal(item.id, index)" :ref="`check-gift-${index}`" v-if="!isGift(item)"/>
              <input type="checkbox" @click="showOfferModal(item.id, index)" :ref="`check-gift-${index}`" checked v-else />
              <div class="control_indicator"></div>
            </label>
          </div>
        </div>
        <!-- Price -->
        <div class="Col Price">
          {{ item.variant.price }}€
        </div>

        <!-- Quantity -->
        <div class="Col">
          <cart-item-quantifier
            v-if="!$store.state.shop.isLoading"
            :display-quantifier="isGift(item)"
            :quantity="item.quantity"
            @up="onAdd(item, item.quantity)"
            @down="onDecrease(item, item.quantity)"
          />

          <loader v-if="$store.state.shop.isLoading" />
        </div>
        <!-- Total -->
        <div v-if="$mq !== 'mobile'" class="Col Price">
          {{ price(item.variant.price, item.quantity) }}
        </div>
      </div>

      <div class="Row SubTotal">
        {{ $t('shop.cartInformations.subtotal') }}: {{ subTotal }} €
      </div>

      <div class="Row Vouchers">
        <vouchers />
      </div>

      <!-- <div class="Row Shipping" v-if="requiresShipping">
        {{ $t('shop.cartInformations.shippingPrice') }}: {{ shippingPrice }}€
      </div> -->

      <div class="Total">{{ t('total', { total }) }}</div>
      <div class="Taxes">{{ t('taxesText') }}</div>

      <div class="Button">
        <vv-button @click="pay">{{ t('pay') }}</vv-button>
      </div>
    </div>

    <div v-else :class="{ CartEmpty: true, 'CartEmpty--small': $mq === 'mobile' }">
      <h1>{{ t('empty.title') }}</h1>
      <img src="@/assets/cart-empty.png" class="Asset" />
    </div>

    <modal name="offer-masterclass-modal"  :adaptive="true" :reset="true" @before-close="beforeClose">
      <modal-gift :masterclass="masterclassGift" @propagate-close-modal="closeOfferModal" @propagate-validate-gift="validateOfferGift"></modal-gift>
    </modal>
  </vv-screen-wrapper>
</template>

<script>
import shopMixin from '@/mixins/shop'
import userMixin from '@/mixins/user'
import { VvScreenWrapper, VvButton } from '@/components/common'
import CartItemQuantifier from '@/components/shop/CartItemQuantifier'
import Vouchers from '@/components/shop/Vouchers'
import ModalGift from '@/components/shop/ModalGift'
import Loader from "@/components/common/Loader"

import { mapGetters } from 'vuex'

import { CREATE_GIFT_DISCOUNT } from '@/store/modules/shop/types'


export default {
  name: 'Cart',
  components: { Loader, VvScreenWrapper, CartItemQuantifier, Vouchers, VvButton, ModalGift },
  mixins: [userMixin, shopMixin],
  data() {
    return {
      masterclassGift: null,
      indexCheckbox: null,
      successAdd: false
    }
  },
  computed: {
    ...mapGetters({
      getShopMasterclasses: 'getShopMasterclasses'
    })
  },
  created() {
    this.assertLogged()
  },
  methods: {
    t(key, params) {
      return this.$t(`cart.${key}`, params)
    },
    onRemove(item) {
      this.updateQuantity(item, 0)
    },
    onAdd(item, quantity) {
      this.updateQuantity(item, quantity + 1)
    },
    onDecrease(item, quantity) {
      this.updateQuantity(item, quantity - 1)
    },
    pay() {
      this.$router.push({
        name: 'CartInformations'
      })
    },
    price(value, quantity) {
      if (!value || !quantity) return null

      return `${(Number(value) * Number(quantity)).toFixed(2)}€`
    },
    imageSrc(item) {
      if (item.variant.image) {
        return item.variant.image.src
      }

      return 'https://cdn.shopify.com/shopifycloud/shopify/assets/checkout/product-blank-98d4187c2152136e9fb0587a99dfcce6f6873f3a9f21ea9135ed7f495296090f.png'
    },
    isGift(item) {
      if ('customAttributes' in item && item.customAttributes.find(att => 'key' in att && att.key == "gift" && att.value != null && att.value !== "{}")) return true
      else return false
    },
    type(item) {
      let type = 'customAttributes' in item && item.customAttributes.find(att => 'key' in att && att.key == "type")['value']
      if (type)
        return parseInt(type)
      return null
    },
    showOfferModal(themeId, index) {
      const isChecked = this.$refs[`check-gift-${index}`][0].checked
      this.successAdd = false
      this.masterclassGift = this.items.find(it => it.id == themeId)
      if (isChecked) {
        this.indexCheckbox = index
        this.$modal.show('offer-masterclass-modal');
      } else {
        this.removeGift(this.masterclassGift)
      }
    },
    closeOfferModal() {
      if (this.indexCheckbox && this.successAdd == false) {
        this.$refs[`check-gift-${this.indexCheckbox}`][0].checked = false
        this.masterclassGift = null
        this.indexCheckbox = null
      }
      this.$modal.hide('offer-masterclass-modal');
    },
    beforeClose() {
      if (this.indexCheckbox != null && this.successAdd == false) {
        this.$refs[`check-gift-${this.indexCheckbox}`][0].checked = false
        this.masterclassGift = null
        this.indexCheckbox = null
      }
    },
    validateOfferGift(value) {
      if (value && value.variantId) {
        // Add to cart with the variantId, quantity = 0, type (1 or 2) and emailGift
        this.updateProduct(value.variantId, 1, this.type(this.masterclassGift), {
          lastname: value.lastnameGift,
          firstname: value.firstnameGift,
          email: value.emailGift
        })
        this.successAdd = true
        this.$modal.hide('offer-masterclass-modal');
      } else {
        this.successAdd = false
        this.$modal.hide('offer-masterclass-modal');
        console.log('error no value for modal offer gift')
      }
    },
    removeGift(masterclass) {
      this.updateProduct(masterclass.id, 1, this.type(masterclass))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

/deep/ .v--modal {
  margin-left: auto !important;
  margin-right: auto !important;
  left: 0 !important;
  right: 0!important;
  height: 550px !important;
  top: 100px !important;
}

.Cart {
  padding-bottom: 20px;

  h1 {
    margin-top: 30px;
    text-align: center;
    font-size: 30px;
  }

  .ToShop {
    cursor: pointer;
    text-decoration: underline;
    color: $primary;
    text-align: center;
  }

  .Row {
    width: 70%;
    margin: 0 auto;
    display: flex;
    margin-bottom: 15px;

    .Col {
      display: inline-flex;
      flex-direction: row;
      width: calc(40% / 3);

      &.Large {
        width: 60%;
      }
    }
  }

  .Header {
    text-transform: uppercase;
    font-size: 12px;
    margin-top: 50px;
  }

  .Product {
    align-items: center;

    .ProductImage {
      max-height: 120px;
      max-width: 120px;
    }

    .Informations {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 30px;

      .Name {
        font-weight: bold;
      }

      .Remove {
        cursor: pointer;
        color: $primary;
        text-decoration: underline;
        font-size: 14px;
        margin-top: 10px;
      }
    }

    .Price {
      font-size: 14px;
    }
  }

  .Vouchers {
    justify-content: flex-end;
  }

  .SubTotal {
    display: flex;
    justify-content: flex-end;
    font-size: 22px;
  }

  .Total {
    margin-top: 20px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .Shipping {
    display: flex;
    justify-content: flex-end;
  }

  .Taxes {
    font-size: 12px;
    text-align: center;
    margin: 12px 0;
  }

  .Button {
    text-align: center;
    margin-top: 30px;
  }

  &--small {
    .Row {
      width: 90%;

      .Col {
        width: calc(40% / 2);

        .Large {
          width: 60%;
        }
      }
    }

    .Product {
      .ProductImage {
        max-width: 90px;
        max-height: 90px;
      }

      .Informations {
        margin-left: 15px;
      }
    }

    .Vouchers {
      margin-top: 30px;
    }
  }
}

.CartEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 94px);

  h1 {
    font-size: 40px;
    margin-top: 50px;
    margin-bottom: 30px;
  }

  .Asset {
    height: 60vh;
    width: auto;
  }

  &--small {
    h1 {
      font-size: 35px;
    }

    .Asset {
      height: 60vh;
      max-width: 95%;

      @media (max-width: 450px) {
        height: 300px;
      }
    }
  }
}

.control {
  font-family: arial;
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 5px;
  padding-top: 3px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control_indicator {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background: transparent;
  border: 2px solid #d10a4a;
  border-radius: 0px;
}
.control:hover input ~ .control_indicator,
.control input:focus ~ .control_indicator {
  background: transparent;
}

.control:hover input ~ .control_indicator,
.control input:hover ~ .control_indicator {
  background: #d10a4a;
}

.control input:checked ~ .control_indicator {
  background: #d10a4a;
}
.control:hover input:not([disabled]):checked ~ .control_indicator,
.control input:checked:focus ~ .control_indicator {
  background: #d10a4a;
}
.control input:disabled ~ .control_indicator {
  background: transparent;
  opacity: 0.6;
  pointer-events: none;
}
.control_indicator:after {
  box-sizing: unset;
  content: '';
  position: absolute;
  display: none;
}
.control input:checked ~ .control_indicator:after {
  display: block;
}
.control-checkbox .control_indicator:after {
  left: 4px;
  top: 0px;
  width: 6px;
  height: 13px;
  border: solid #ffffff;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.control-checkbox input:disabled ~ .control_indicator:after {
  border-color: #7b7b7b;
}
</style>
